module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av675-faf416428d1cfb9681ce11e001bbdebc.jpg";